<div class="feature">
  <!-- Display title if provided -->
  @if (featureTitle) {
  <h3>{{ featureTitle }}</h3>
  }
  <!-- ...existing content... -->
  <ng-content></ng-content>
</div>